"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLine = exports.MessageWrapper = exports.ButtonGroupWrapper = exports.IconContainer = exports.Message = exports.MessageContainer = exports.ActionContainer = exports.Label = exports.HeaderWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.HeaderWrapper = styled_components_1.default.div `
  display: grid;
  position: relative;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-items: center;
  height: 68px;
  padding: 0 64px;
  background-color: ${colors_1.WHITE};
  border: 1px solid ${colors_1.LIGHT_GREY};

  @media (max-width: 1399px) {
    padding: 0 32px;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
  }
  @media (max-width: 687px) {
    display: flex;
    height: 100%;
    padding: 16px 0;
    flex-direction: column-reverse;
  }
`;
exports.Label = styled_components_1.default.div `
  font-weight: bold;
  justify-self: flex-start;
  display: flex;
  align-items: center;
  @media (max-width: 687px) {
    text-align: center;
    margin-top: 16px;
  }

  & > div {
    cursor: pointer;

    & > div + div {
      font-weight: normal;
      text-align: center;
      max-width: 280px;
      opacity: 1 !important;
      padding-top: 15px;
      padding-bottom: 15px;
      cursor: default;

      & a {
        display: block;
        color: ${colors_1.PALE_GREEN};
        cursor: pointer;
        font-weight: bold;
      }
    }
  }
`;
exports.ActionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 687px) {
    display: none;
  }
`;
exports.MessageContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  margin: 0 12px;
  align-items: center;
  @media (min-width: 688px) and (max-width: 768px) {
    margin-left: 4px;
  }
`;
exports.Message = styled_components_1.default.p `
  color: ${({ $color }) => ($color ? $color : colors_1.DARK_GREEN)};
  font-size: 16px;
  margin: 0;
  @media (max-width: 1919px) {
    display: none;
  }
`;
exports.IconContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
  cursor: pointer;
`;
exports.ButtonGroupWrapper = styled_components_1.default.div `
  display: grid;
  grid-auto-flow: column;
  grid-gap: 16px;
  margin-left: 8px;

  @media screen and (min-width: 1200px) {
    * {
      text-transform: uppercase;
      font-weight: 700;
    }
  }
`;
exports.MessageWrapper = styled_components_1.default.div ``;
exports.HorizontalLine = styled_components_1.default.hr `
  order: 6;
  align-self: stretch;
  flex-grow: 0;
  margin: 8px 0px;
  border: 1px solid ${colors_1.GREY2};
  background-color: ${colors_1.GREY2};
`;
//# sourceMappingURL=Header.styles.js.map